import { fetchAllCmsBrandsForAppId } from '../Entities/CmsBrands/cmsbrands.saga';
import { gotoSite } from '../Navigation/navigation.actions';
import { cmsBrandSaveCallOptions } from '../../services/cmsbrands.services';
import { CmsBrand } from '../Entities/CmsBrands/cmsbrands.reducer';
import { showSnackbarWithMessage } from '../Snackbar/snackbar.saga';
import { countryByShortcode } from '../../utils/country';
import { getBrandById } from '../Entities/Brands/brands.reducer';
import { brandListCallOptions } from '../../services/brandlist.services';
import { brandSchema } from '../Entities/Brands/brands.saga';
import { callApi } from '../api';
import { call, fork, put, select, take } from 'redux-saga/effects';
import { normalize } from 'normalizr';
import {
  addBrand,
  getBrandList,
  paginateBrandList,
  updateBrandList,
} from './brandlist.actions';

function* fetchBrandList(page?: number) {
  const {
    brandList: { searchQuery },
  } = yield select() as any;

  const params = {
    ...(searchQuery ? { 'filter[search]': searchQuery } : {}),
    ...(page ? { page: page } : {}),
  };

  const callOptions = brandListCallOptions(params);
  const data = yield call(callApi, callOptions);
  if (data && data.ok) {
    const normalizedBrandList = normalize(data.data, {
      data: [brandSchema],
    }) as any;

    yield put(
      updateBrandList({
        pagination: normalizedBrandList.result.meta.pagination,
        brandIds: normalizedBrandList.result.data,
      })
    );
  }
}

export function* watchForBrandListLoad() {
  yield take(getBrandList.type);

  const {
    brandList: { pagination },
  } = yield select() as any;

  yield fetchBrandList(pagination ? pagination.currentPage : 1);
}

export function* watchForBrandListPagination() {
  while (true) {
    const {
      payload: { page },
    } = yield take(paginateBrandList.type);

    yield fetchBrandList(page);
  }
}
export function* watchForBrandAdd() {
  while (true) {
    const {
      payload: { id, gender },
    } = yield take(addBrand.type);
    const state = yield select() as any;
    const appId = countryByShortcode(state.country).id;
    const brand = getBrandById(state, appId, id);

    yield saveBrand({
      ...brand,
      slug: null,
      images: [],
      gender: gender,
    } as CmsBrand);
  }
}

export function* saveBrand(cmsBrand: CmsBrand) {
  const saveCallOptions = cmsBrandSaveCallOptions(cmsBrand);
  const brandResponse = yield call(callApi, saveCallOptions);
  if (brandResponse.ok) {
    yield put(gotoSite(`brands/${cmsBrand.id}/edit`));
    yield fork(showSnackbarWithMessage, 'success', 'Brand added');
    yield fork(updateBrandEntities);
  } else {
    showSnackbarWithMessage('error', 'Brand could not be added');
  }
}

function* updateBrandEntities() {
  const {
    brandEdit: { activeAppId },
  } = yield select();
  yield call(fetchAllCmsBrandsForAppId, activeAppId);
}



// WEBPACK FOOTER //
// ./src/store/BrandList/brandlist.saga.ts